import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-12 md:col-6 sm:col-6 lg:col-2" }
const _hoisted_4 = { for: "date" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field col-12 md:col-6 sm:col-6 lg:col-2" }
const _hoisted_8 = { for: "fromTime" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "field col-12 md:col-6 sm:col-6 lg:col-2" }
const _hoisted_12 = { for: "toTime" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "field col-12 md:col-6 sm:col-6 lg:col-4" }
const _hoisted_16 = { for: "toTime" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}

import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import InputNumber from 'primevue/inputnumber'

import {inject, onMounted, reactive, ref, watch} from 'vue'
import {FormDataType, TimelineRules, TimelineType} from "@/components/blocks/TimelineDefs";
import InputField from "@/components/blocks/InputField.vue";
import ProjectField from "@/components/blocks/ProjectField.vue";

import {AxiosStatic} from "axios";
import useVuelidate from "@vuelidate/core";
import {useDataStore} from "@/stores/DataStore";

import {saveTimeline, updateTimeline} from "@/components/blocks/TimelineUtils";

// Define types
type PropsType = {
  display: boolean,
  row: TimelineType | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineRowEdit',
  props: {
    display: { type: Boolean },
    row: null
  },
  emits: ['update:display', 'update:row', 'updated'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  display: boolean,
  row: TimelineType | null
};


const formData = reactive<FormDataType>({
  id: null,
  project: null,
  date: new Date(),
  fromTime: null,
  toTime: null,
  note: null,
  pause: 30
})

// Define stores
const dataStore = useDataStore()

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define props


// Define emits


// Define lifecycle
onMounted(() => {
  visible.value = props.display
})

// Define refs
const visible = ref<boolean>(false)
const v$ = useVuelidate(TimelineRules, formData)
const submitted = ref<boolean>(false)
const errorMessage = ref<string | null>(null)

// Define watch
watch(() => props.display, (cur, prev) => {
  visible.value = cur
})
watch(() => props.row, (cur, prev) => {
  if (cur != null) {
    formData.project = dataStore.getProjects.filter(it => it.id == cur.projectId)[0]
    formData.note = cur.note
    formData.pause = cur.pause
    formData.fromTime = new Date(cur.fromTime)
    formData.date = new Date(cur.fromTime)
    formData.toTime = new Date(cur.toTime)
    formData.id = cur.id
  }
})

// Define functions
function hideDialog() {
  emits('update:row', null)
  emits('update:display', false)
}

function handleChangeVisibility(current: boolean) {
  emits('update:display', current)
}

function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    updateTimeline(axios, formData, (data) => {
      submitted.value = false
      emits('update:row', data.data)
      emits('update:display', false)
    }, (response) => {
      console.error('Can not update timeline', response)
    })
  } else {
    console.error('Form is not valid!')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    header: "Header",
    visible: visible.value,
    "onUpdate:visible": [
      _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
      handleChangeVisibility
    ],
    modal: true,
    position: "top",
    breakpoints: {'960px': '75vw', '640px': '90vw'},
    style: {width: '50vw'}
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        label: "Cancel",
        icon: "pi pi-times",
        class: "p-button-text",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (hideDialog()))
      }),
      _createVNode(_unref(Button), {
        label: "Save",
        icon: "pi pi-check",
        autofocus: "",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (handleSubmit(!_unref(v$).$invalid)))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode("Date "),
                (_unref(v$).date.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "date",
                dateFormat: "dd.mm.yy",
                class: _normalizeClass({'p-invalid':_unref(v$).date.$invalid && submitted.value}),
                modelValue: _unref(v$).date.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).date.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).date.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).date.required.$message.replace('Value', 'Date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createTextVNode("From Time "),
                (_unref(v$).fromTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "fromTime",
                dateFormat: "HH:MM",
                class: _normalizeClass({'p-invalid':_unref(v$).fromTime.$invalid && submitted.value}),
                timeOnly: true,
                hourFormat: "24",
                stepMinute: 15,
                modelValue: _unref(v$).fromTime.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).fromTime.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).fromTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_unref(v$).fromTime.required.$message.replace('Value', 'Time from')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode("To Time "),
                (_unref(v$).toTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "toTime",
                dateFormat: "HH:MM",
                class: _normalizeClass({'p-invalid':_unref(v$).toTime.$invalid && submitted.value}),
                timeOnly: true,
                hourFormat: "24",
                stepMinute: 15,
                modelValue: _unref(v$).toTime.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).toTime.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).toTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_unref(v$).toTime.required.$message.replace('Value', 'Time to')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, [
                _createTextVNode("Pause "),
                (_unref(v$).toTime.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(InputNumber), {
                modelValue: _unref(v$).pause.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).pause.$model) = $event)),
                id: "pause",
                min: 0,
                step: 15,
                allowEmpty: false,
                showButtons: "",
                buttonLayout: "horizontal",
                decrementButtonClass: "p-button-danger",
                incrementButtonClass: "p-button-success",
                incrementButtonIcon: "pi pi-plus",
                decrementButtonIcon: "pi pi-minus",
                suffix: " min",
                mode: "decimal"
              }, null, 8, ["modelValue"]),
              (_unref(v$).toTime.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_unref(v$).toTime.required.$message.replace('Value', 'Pause')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(ProjectField, {
              class: "col-12 md:col-6 sm:col-6 lg:col-4",
              id: "project",
              label: "Project",
              modelValue: _unref(v$).project.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).project.$model) = $event)),
              vualidate: _unref(v$).project,
              submitted: submitted.value
            }, null, 8, ["modelValue", "vualidate", "submitted"]),
            _createVNode(InputField, {
              id: "note",
              class: "field col-12 md:col-10 sm:col-10 lg:col-8",
              label: "Note",
              vualidate: _unref(v$).note,
              submitted: submitted.value,
              modelValue: formData.note,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.note) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})